const StateData = {

    contextMain: [
        {
            link: 'https://dzen.ru/video/watch/635914dd775e6714600553c6?share_to=link',
            name: 'Русский шаффл',
            subs: '3,7K подписчиков',
            video: 'assets/img/1.mp4',
            date: 'вчера • 18,1K просмотров',
            number1: '201',
            number2: '201',
            number3: '',
            title: false,
            excerpt: ''
        },
        {
            link: 'https://dzen.ru/video/watch/61e92ad0fe3dd1453e71c953?share_to=link',
            name: 'Юлия Парфенова',
            subs: '65,5K подписчиков',
            video: 'assets/img/2.mp4',
            date: 'вчера • 27,6K просмотров',
            number1: '1K',
            number2: '77',
            number3: '',
            title: false,
            excerpt: ''
        },
        {
            link: 'https://dzen.ru/video/watch/61a5e82a0550eb562f570729?share_to=link',
            name: 'Простая История',
            subs: '3,9K подписчиков',
            video: false,
            date: '1 год назад • 3,3K просмотров',
            number1: '35',
            number2: '',
            number3: '',
            title: 'Вся Эпоха Возрождения за 10 минут',
            excerpt: ''
        },
        {
            link: 'https://dzen.ru/video/watch/5f8030e70ed9ec1e0a187547?share_to=link',
            name: 'Нескучная классика',
            subs: '41,2K подписчик',
            video: false,
            date: '11 октября 2020 • 19К просмотров',
            number1: '195',
            number2: '10',
            number3: '',
            title: 'Ямб или хорей? Разбираемся раз и навсегда со стихотворными размерами',
            excerpt: ''
        },
        {
            link: 'https://dzen.ru/a/XjGGB1aYPxR2HPOU?share_to=link',
            name: 'Мел',
            subs: '252K подписчиков',
            video: false,
            date: '29 января 2020 • 1,9K прочитали',
            number1: '112',
            number2: '2',
            number3: '',
            title: 'Что и как можно выучить во сне',
            excerpt: '«Когда вы сегодня пойдёте спать, положите книжку под подушку. Проснувшись, вы вспомните всё, что там было написано», — так звучит самый несправедливый обман детства...'
        },
    ],
    contextSecondSession: false,
    contextSession: 1,
    contextScore: 0,
    contextCurrentQuestion: 0,
    contextQuestionsForUser: false,
    contextUserAnswers: [-1,-1,-1,-1,-1],
    contextQuestions: [
        { //0. mendeleev
            text: 'Все просмотры под роликами о&nbsp;химии — мои! А ещё я люблю видео о создании таблиц в Excel (пока не уверен, что такие таблицы мне подходят).',
            answers: ['Томас Эдисон','Дмитрий Менделеев','Михаил Ломоносов'],
            correct: 1,
            right: 'Всё верно! Тебе приснился этот ответ?',
            wrong: 'Нет, это другой гений!',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/62d044407024e56b3ba19d34?share_to=link',
                    name: 'Химия – Просто',
                    subs: '6,4К подписчиков',
                    video: '0.mp4',
                    date: 'вчера • 2,3К просмотров',
                    number1: '142',
                    number2: '3',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/XjGGB1aYPxR2HPOU?share_to=link',
                    name: 'Мел',
                    subs: '252K подписчиков',
                    video: false,
                    date: '29 января 2020 • 1,9K прочитали',
                    number1: '111',
                    number2: '2',
                    number3: '',
                    title: 'Что и как можно выучить во сне',
                    excerpt: '«Когда вы сегодня пойдёте спать, положите книжку под подушку. Проснувшись, вы вспомните всё, что там было написано», — так звучит самый несправедливый обман детства...'
                },
                {
                    link: 'https://dzen.ru/video/watch/63a805cdc74e581267c3b03f?share_to=link',
                    name: 'Канал Наука',
                    subs: '113,2K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 1,5К просмотров',
                    number1: '97',
                    number2: '24',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/60bb57c73adb654fa5cb44a9?share_to=link',
                    name: 'ИнтерФакт',
                    subs: '1.2K подписчиков',
                    video: false,
                    date: '15 Февраля • 93К просмотров',
                    number1: '112',
                    number2: '2',
                    number3: '',
                    title: 'Создание таблицы в Excel простыми словами / Урок excel для начинающих',
                    excerpt: ''
                },
            ]
        },
        { //1. lyaga
            text: 'Знаю наизусть все&nbsp;видео с&nbsp;советами для&nbsp;путешествий, восхищаюсь роликами с&nbsp;красивыми местами и&nbsp;ставлю лайки статьям об&nbsp;экзотических местных блюдах.',
            answers: ['Лягушка-путешественница','Христофор Колумб','Синдбад-мореход'],
            correct: 0,
            right: 'Именно! С&nbsp;ней&nbsp;не&nbsp;страшно и&nbsp;в&nbsp;кругосветку рвануть, и&nbsp;экзотические блюда попробовать.',
            wrong: 'А вот и нет.',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/636bf6db7d09ee0d49b6bf64?share_to=link',
                    name: 'Марк Ерёмин. Путешествия',
                    subs: '9,3K подписчиков',
                    video: '0.mp4',
                    date: 'вчера • 577 просмотров',
                    number1: '29',
                    number2: '',
                    number3: '133',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/YBL-eDx5XVj9y65z?share_to=link',
                    name: 'basket of secrets',
                    subs: '2,5K подписчиков',
                    video: false,
                    date: '28 января 2021 • 2,7K прочитали',
                    number1: '11',
                    number2: '3',
                    number3: '',
                    title: 'Почему городские утки не улетают зимой на юг?',
                    excerpt: 'То ли зимы у нас стали теплее, то ли утки обленились, но в последнее время этих птиц можно встретить в городе даже зимой. Причем даже в таких местах, где поблизости нет большого пространства открытой воды.'
                },
                {
                    link: 'https://dzen.ru/video/watch/63ab4bd0f85ac32531a2da41?share_to=link',
                    name: 'Путешествия без багажа',
                    subs: '23,4K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 23,8K просмотров',
                    number1: '321',
                    number2: '8',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/62345775fb74e72a55b46341?share_to=link',
                    name: 'Какого Жука?!',
                    subs: '71 подписчик',
                    video: false,
                    date: '18 марта • 68 просмотров',
                    number1: '22',
                    number2: '2',
                    number3: '',
                    title: 'ПРОБУЕМ ЕСТЬ НАСЕКОМЫХ! Готовим саранчу и мучного червя. Простые рецепты из насекомых!',
                    excerpt: ''
                },
            ]
        },
        { //2. pushkin
            text: 'Творческая натура и&nbsp;вольнодумец.&nbsp;Фанат статей о&nbsp;русском слове, видео о&nbsp;мужской&nbsp;моде XIX века и&nbsp;роликов о&nbsp;дуэлях.',
            answers: ['Александр Пушкин','Михаил Булгаков','Марк Твен'],
            correct: 0,
            right: 'Какое чудное мгновенье — всё&nbsp;правильно.',
            wrong: 'Упс! Чуть-чуть мимо.',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/61aa109674e6e8450f29a463?share_to=link',
                    name: 'История России',
                    subs: '612,9K подписчиков',
                    video: '0.mp4',
                    date: 'вчера • 90,2K просмотров',
                    number1: '3,1К',
                    number2: '94',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/Yw5Ai9O_mQPWM_iD?share_to=link',
                    name: 'Black Tie',
                    subs: '23,3K подписчиков',
                    video: false,
                    date: '30 августа 2022 • 673 прочитали',
                    number1: '106',
                    number2: '4',
                    number3: '',
                    title: 'Мужская красота с точки зрения 19-го века',
                    excerpt: 'Читаю я&nbsp;тут Г.&nbsp;Прево «Искусство одеваться» за&nbsp;1892&nbsp;год&nbsp;и&nbsp;французские журналы мод&nbsp;начала 19-го века и&nbsp;нахожу много интересно. С&nbsp;Прево проще&nbsp;— он&nbsp;написан на&nbsp;дореволюционном, а&nbsp;значит&nbsp;— вполне читабелен…'
                },
                {
                    link: 'https://dzen.ru/video/watch/62432270c511d521136c0f3c?share_to=link',
                    name: 'Русская армия. История.',
                    subs: '78,5K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 8,9K просмотров',
                    number1: '105',
                    number2: '2',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/5f8030e70ed9ec1e0a187547?share_to=link',
                    name: 'Нескучная классика',
                    subs: '41,2K подписчик',
                    video: false,
                    date: '11 октября 2020 • 19К просмотров',
                    number1: '195',
                    number2: '10',
                    number3: '',
                    title: 'Ямб&nbsp;или&nbsp;хорей? Разбираемся раз&nbsp;и&nbsp;навсегда со&nbsp;стихотворными размерами',
                    excerpt: ''
                },
            ]
        },
        { //3. cleo
            text: 'Питаю страсть к&nbsp;статьям о&nbsp;секретах вечной молодости, роликам о&nbsp;культуре Древнего Египта и&nbsp;каждый день совершенствую свой макияж с&nbsp;туториалами на&nbsp;идеально ровные стрелки.',
            answers: ['Клеопатра','Золушка','Афродита'],
            correct: 0,
            right: 'Правильно! Клеопатре явно нелегко жить в&nbsp;мире, в&nbsp;котором салат назван в&nbsp;честь бывшего.',
            wrong: 'Ошибочка вышла.',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/62d0d728c8e53e490f765a6e',
                    name: 'cheh_artur',
                    subs: '8,5K подписчиков',
                    video: '0.mp4',
                    date: 'вчера • 2,2K просмотров',
                    number1: '361',
                    number2: '2',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/Yez6rBsof1xtgZtm?share_to=link',
                    name: 'Домашняя кухня Алексея Соколова',
                    subs: '105,8K подписчиков',
                    video: false,
                    date: '23 января 2022 • 19K прочитали',
                    number1: '1К',
                    number2: '154',
                    number3: '',
                    title: 'Это будет ваш лучший «Цезарь», он удивит вкусом. Подробный рецепт самого популярного ресторанного салата от «А» до «Я»',
                    excerpt: 'Добрый день! :) Легенда гласит, что классический салат «Цезарь» – это листья романо, сухари, майонезный соус и пармезан и все. Но по миру этот салат разошелся в несколько обогащенном составе. Теперь в него, в зависимости от рецепта и прихотей повара, добавляют и курицу,'
                },
                {
                    link: 'https://dzen.ru/video/watch/61e92ad0fe3dd1453e71c953?share_to=link',
                    name: 'Юлия Парфенова',
                    subs: '65,5K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 27,6K просмотров',
                    number1: '1К',
                    number2: '77',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/62fb9cafe09e9250d656f297?share_to=link',
                    name: 'Стань краше с Орловой Дашей',
                    subs: '78,4K подписчик',
                    video: false,
                    date: '5 месяцев назад • 6.1К просмотров',
                    number1: '296',
                    number2: '20',
                    number3: '',
                    title: '💎 Как НАДОЛГО сохранить красоту и молодость лица? 👉 3 ежедневных АНТИЭЙДЖ - приёма из фейсфитнеса',
                    excerpt: ''
                },
            ]
        },
        { //4. charlie
            text: 'Вижу мир&nbsp;чёрно-белым. Обожаю статьи об&nbsp;актёрском мастерстве и&nbsp;обзоры на&nbsp;трости. Смотрю видео&nbsp;без&nbsp;звука, и&nbsp;мне&nbsp;это&nbsp;нравится.',
            answers: ['Альфред Хичкок','Чарли Чаплин','Луи Люмьер'],
            correct: 1,
            right: 'Немой восторг! Всё так.',
            wrong: 'Ну как же так. В следующий раз не торопись.',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/61c82723d6de7d63892852b1?share_to=link',
                    name: 'Невероятные факты - Антона Чалей',
                    subs: '20K подписчиков',
                    video: '0.mp4',
                    date: 'вчера • 113,9K просмотров',
                    number1: '185',
                    number2: '12',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/YF1ngFioiRcx8Wzn?share_to=link',
                    name: 'script bro | сценаристы',
                    subs: '2,9K подписчиков',
                    video: false,
                    date: '21 января 2020 • 16K прочитали',
                    number1: '709',
                    number2: '43',
                    number3: '',
                    title: 'ЧТО ДЕЛАЕТ ПЕРСОНАЖЕЙ СМЕШНЫМИ?',
                    excerpt: 'Написание классных комедийных сценариев не&nbspсводится к&nbspсюжету, теме или&nbspдаже, как&nbspпринято считать, к&nbspдиалогам. Всё&nbspсводится к&nbspтому, насколько забавны ключевые персонажи. Построены&nbspли&nbspони таким образом, что&nbspсмешны сами по&nbspсебе?'
                },
                {
                    link: 'https://dzen.ru/video/watch/63d260a533913053899bc574',
                    name: 'Журнал «Хроника»',
                    subs: '41K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 128 просмотров',
                    number1: '5',
                    number2: '',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/6239908e3c14f46c08f14058?share_to=link',
                    name: 'Лекторий Dостоевский',
                    subs: '46,4K подписчик',
                    video: false,
                    date: '10 месяцев назад • 108 просмотров',
                    number1: '',
                    number2: '',
                    number3: '',
                    title: 'Актерское мастерство. Система Станиславского | Как стать актером | Избавляемся от телесных зажимов',
                    excerpt: ''
                },
            ]
        },
        { //5. IOWA
            text: 'Улыбаюсь миру каждый день!&nbsp;Люблю смотреть ролики&nbsp;об&nbsp;истории музыки&nbsp;и&nbsp;неравнодушна к&nbsp;эстетике&nbsp;общественного транспорта.',
            answers: ['Сирена','IOWA','Бритни'],
            correct: 1,
            right: 'У тебя меткий глаз. Это не шутки!',
            wrong: 'Не совсем. Но ты, как говорится, улыбайся!',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/635914dd775e6714600553c6?share_to=link',
                    name: 'Русский шаффл',
                    subs: '3,7K подписчиков',
                    video: '0.mp4',
                    date: 'вчера • 18,1K просмотров',
                    number1: '201',
                    number2: '9',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/XWVXaR6OPwCt9PMH',
                    name: 'Спортивный накал',
                    subs: '3,4K подписчиков',
                    video: false,
                    date: '27 августа 2019 • 817 прочитали',
                    number1: '11',
                    number2: '5',
                    number3: '',
                    title: 'Маршрутные такси СССР. Что&nbsp;было до&nbsp;Газели?',
                    excerpt: 'В последние годы во многих городах наблюдается тенденция по вытеснению микроавтобусов «Газель» с городских маршрутов. Во-первых, это связано с возросшей доступностью иностранных микроавтобусов. Во-вторых, «Газели» хоть и модернизировались, но все же несколько устарели. '
                },
                {
                    link: 'https://dzen.ru/video/watch/6331a105690e046a6b8cb45b?share_to=link',
                    name: 'Откуда Ноты Растут',
                    subs: '5,1K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 284 просмотра',
                    number1: '52',
                    number2: '',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/638b8340d5b6f74829528acb?share_to=link',
                    name: 'Молодость без уколов',
                    subs: '113,7K подписчик',
                    video: false,
                    date: '2 месяца назад • 15,1K просмотров',
                    number1: '527',
                    number2: '8',
                    number3: '',
                    title: '5 упражнений чтобы научиться правильно и красиво улыбаться',
                    excerpt: ''
                },
            ]
        },
        { //6. da vinci
            text: 'Люблю смотреть видеоуроки по&nbsp;рисованию, читать статьи об&nbsp;изобретениях и&nbsp;мечтаю создать&nbsp;что-то, о&nbsp;чём&nbsp;будут говорить через&nbsp;100&nbsp;лет.',
            answers: ['Васко да Гама','Клод Моне','Леонардо да&nbsp;Винчи'],
            correct: 2,
            right: 'В&nbsp;точку! Творец, изобретатель и&nbsp;просто легенда эпохи Возрождения.',
            wrong: 'Внимательнее ищи подсказки.',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/6388fdc524a4b34a83968e05?share_to=link',
                    name: 'Александр Рыжкин <br>& Арт-студия Виталия Лещенко',
                    subs: '3,7K подписчиков',
                    video: '0.mp4',
                    date: 'вчера • 1K просмотров',
                    number1: '107',
                    number2: '',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/XbG8onnCbgCwFf9P',
                    name: 'BAD GEAR',
                    subs: '3,6K подписчиков',
                    video: false,
                    date: '24 октября 2019 • 24K прочитали',
                    number1: '428',
                    number2: '48',
                    number3: '',
                    title: 'Личный вертолет в гараже своими руками. Результаты трудов Российских умельцев',
                    excerpt: 'Леонардо да&nbsp;Винчи&nbsp;— первый человек, в&nbsp;летописях которого были обнаружены упоминания о&nbsp;летательном аппарате, похожего на&nbsp;вертолёт. Конструкция была настолько примитивна, что&nbsp;своё продолжение не&nbsp;получила.'
                },
                {
                    link: 'https://dzen.ru/video/watch/63209ea9e772054853b770c3',
                    name: 'Уроки рисования АРТ ВЕРЕСК',
                    subs: '8K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 533 просмотра',
                    number1: '66',
                    number2: '2',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/61a5e82a0550eb562f570729?share_to=link',
                    name: 'Простая История',
                    subs: '3,9K подписчиков',
                    video: false,
                    date: '1 год назад • 3,3K просмотров',
                    number1: '35',
                    number2: '',
                    number3: '',
                    title: 'Вся Эпоха Возрождения за 10 минут',
                    excerpt: ''
                },
            ]
        },
        { //7. freud
            text: 'Я&nbsp;здесь осознанно. Читаю статьи&nbsp;о&nbsp;психологии и&nbsp;пытаюсь&nbsp;разобраться в&nbsp;своём&nbsp;детстве.',
            answers: ['Аристотель','Карл Юнг','Зигмунд Фрейд'],
            correct: 2,
            right: 'Бинго! Ответ подсказало твоё подсознание.',
            wrong: 'Не&nbsp;совсем&nbsp;— ответ спрятан в&nbsp;твоём подсознании.',
            tips: [
                {
                    link: 'https://dzen.ru/video/watch/639f3b9d79dcab7132330f73?share_to=link',
                    name: 'Психолог Александр Кулаков',
                    subs: '134 подписчика',
                    video: '0.mp4',
                    date: 'вчера • 261 просмотров',
                    number1: '9',
                    number2: '',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/a/X4B7tLGk2V3AVYT-?share_to=link',
                    name: 'Северное сияние',
                    subs: '3,6K подписчиков',
                    video: false,
                    date: '10 октября 2020 • 405 прочитали',
                    number1: '11',
                    number2: '1',
                    number3: '',
                    title: 'Как оговорки выдают тайные мысли человека',
                    excerpt: 'Бывает, что&nbsp;при&nbsp;разговоре человек оговаривается, говорит не&nbsp;то&nbsp;что&nbsp;на&nbsp;самом деле собирался. Есть&nbsp;множество причин, почему так&nbsp;происходит.'
                },
                {
                    link: 'https://dzen.ru/video/watch/639ff99eae8e537693a03b3f?t=16',
                    name: 'Неприкрытый гештальт',
                    subs: '19,4K подписчиков',
                    video: '2.mp4',
                    date: 'вчера • 1,5K просмотров',
                    number1: '108',
                    number2: '1',
                    number3: '',
                    title: false,
                    excerpt: ''
                },
                {
                    link: 'https://dzen.ru/video/watch/62595a33ddd8206ea5e576e3?share_to=link',
                    name: 'Мария Самарина про Поток',
                    subs: '6,7K подписчиков',
                    video: false,
                    date: '15 апреля 2021 • 1K просмотров',
                    number1: '44',
                    number2: '',
                    number3: '',
                    title: 'Джо Диспенза о материальности мысли! 💫 Как Мысли МЕНЯЮТ ВАШУ жизнь?',
                    excerpt: ''
                },
            ]
        },
    ],
    contextTitles: [
        'Непонятый гений',
        'Любитель',
        'Начинающий исследователь',
        'Своего рода психолог',
        'Без пяти минут телепат',
        'Гений дедукции'
    ],
    contextResults:[
        'Нестандартно мыслишь и видишь зацепки даже там, где их нет. Продолжай в том же духе — миру нужны такие люди!',
        'Твоё топливо&nbsp;— огонь в&nbsp;глазах и&nbsp;любопытство. Добавить к&nbsp;этому чуть-чуть внимательности&nbsp;— и&nbsp;все&nbsp;рекорды будут твои.',
        'Ты&nbsp;только в&nbsp;начале своего пути, но&nbsp;талант видно издалека. Запасайся пончиками и&nbsp;кофе и&nbsp;продолжай тренироваться разгадывать загадки.',
        'У&nbsp;тебя есть&nbsp;все&nbsp;задатки психолога! Чуть-чуть практики&nbsp;— и&nbsp;ты&nbsp;сможешь разобраться в&nbsp;тонкой душевной организации любого.',
        'Прочитать человека по&nbsp;его&nbsp;соцсетям? Это&nbsp;про&nbsp;тебя! Такой&nbsp;навык точно пригодится в&nbsp;современном мире.',
        'Ты&nbsp;точно нашёл свой Дзен и&nbsp;достиг высочайшего мастерства! От&nbsp;тебя ничего не&nbsp;скроешь: соберёшь все&nbsp;зацепки и&nbsp;раскроешь самое запутанное дело.'
    ],
    contextPeoples: [
        {
            ava: 'assets/img/final/ava0.jpg',
            name: 'Оля Лёля<span>',
            link: 'https://dzen.ru/olyalolyaa',
            channel: 'olyalolyaa'
        },
        {
            ava: 'assets/img/final/ava1.jpg',
            name: 'Яна Динамика<span>',
            link: 'https://dzen.ru/yana_dinamika',
            channel: 'yana_dinamika'
        },
        {
            ava: 'assets/img/final/ava2.jpg',
            name: 'Нутрициолог <span class="natSpan">Наташа Богданкевич',
            link: 'https://dzen.ru/natasha_bogdankevich',
            channel: 'natasha_bogdankevich'
        },
        /*{
            ava: 'assets/img/final/ava3.jpg',
            name: 'Александр Панчин<span>',
            link: 'https://dzen.ru/scinquisitor',
            channel: 'scinquisitor'
        },*/
        {
            ava: 'assets/img/final/ava4.jpg',
            name: '<span class="natSpan">Что почитать?',
            link: 'https://dzen.ru/chto_chitat',
            channel: 'chto_chitat'
        },
        {
            ava: 'assets/img/final/ava5.jpg',
            name: '<span>Это не загуглишь.</span> Яна Сорока<span>',
            link: 'https://dzen.ru/nezagooglish',
            channel: 'nezagooglish'
        },
        /*{
            ava: 'assets/img/final/ava6.jpg',
            name: 'Петровна<span>',
            link: 'https://dzen.ru/ptrvn',
            channel: 'ptrvn'
        },*/
        {
            ava: 'assets/img/final/ava7.jpg',
            name: 'krisartist<span>',
            link: 'https://dzen.ru/krisartist',
            channel: 'krisartist'
        },
    ],
    

}

export default StateData

 

